import { UploadSimple } from '@phosphor-icons/react';

export default UploadSimple;
